"use client";

import Container from "~/components/Container";
import { type FormSection_Fields } from "~/__generated__/graphql";
import UnderlinedLink from "~/components/UnderlinedLink";
import { type PageProps } from "./FlexibleContent";
import { Form } from "~/components/form-builder/Form";

export default function FormSection({
  title,
  location,
  date,
  emailTemplateId,
  formFields,
  submitButtonLabel,
  submitMessage,
  pageData,
}: FormSection_Fields & PageProps) {
  return (
    <section className="black-section bg-black" id="form">
      <Container containerClass="py-10 gap-5">
        <div className="flex-1">
          <h2 className="mb-[0.1875rem] mt-3 text-4xl text-white">{title}</h2>
          {(date || location) && (
            <div className="mt-6 flex gap-6 text-white flex-wrap">
              {date && (
                <div className="flex items-center">
                  <span className="material-icons-round mr-2">
                    calendar_today
                  </span>
                  <span>{date}</span>
                </div>
              )}
              {location && (
                <div className="flex items-center">
                  <span className="material-icons-round mr-2">place</span>
                  {location.link ? (
                    <UnderlinedLink to={location.link.url}>
                      {location.name}
                    </UnderlinedLink>
                  ) : (
                    <span>{location.name}</span>
                  )}
                </div>
              )}
            </div>
          )}
        </div>
        <Form
          pageData={pageData}
          formFields={formFields}
          submitButtonLabel={submitButtonLabel}
          submitMessage={submitMessage}
        />
      </Container>
    </section>
  );
}
